module.exports = __webpack_public_path__ + "img/logo_login.cdbe52e7.png";